<template>
  <div id="main-additional-wrapper">
    <a-row type="flex" align="middle" style="margin-bottom: 10px">
      <a-col>
        <h2 style="margin-bottom: 0">{{ $t("Raporty") }}</h2>
      </a-col>
      <a-col style="flex: 1; margin: 0 10px 0 15px">
        <a-select
          id="report-type"
          style="display: inline-block; width: 100%; box-sizing: border-box"
          :placeholder="$t('Repotr type')"
          v-model="reportType"
          @change="handlerChangeReportType"
        >
          <a-select-option value="employeeStatuses">
            {{ $t("statusEmp") }}
          </a-select-option>
          <a-select-option value="contractTerms">
            {{ $t("TerminyUmow") }}
          </a-select-option>
        </a-select>
      </a-col>

      <a-col v-if="reportType == 'contractTerms'" style="flex: 1">
        <a-row style="flex: 1; height: 100%" type="flex" class="search-wrapper">
          <a-col style="flex: 1">
            <a-dropdown :trigger="['click']">
              <a-input-search
                class="ant-dropdown-link"
                :placeholder="$t('Search by')"
                @search="(e) => handleSearch()"
              >
                <a-tooltip slot="suffix">
                  <a-icon
                    type="info-circle"
                    style="color: rgba(0, 0, 0, 0.45); margin-right: 5px"
                  />
                </a-tooltip>
              </a-input-search>

              <a-menu slot="overlay" style="background-color: #fafafa">
                <a-form
                  :form="form"
                  id="my_form_search_styl"
                  layout="vertical"
                  style="padding: 0 50px"
                >
                  <a-menu-item key="2">
                    <a-form-item :label="$t('Name')">
                      <a-select
                        showSearch
                        mode="multiple"
                        v-decorator="['name', { rules: [{ required: false }] }]"
                        allowClear
                        :filter-option="false"
                        @search="searchUser"
                        @focus="usersReport = userInfo"
                      >
                        <a-select-option
                          v-for="employee of usersReport"
                          :key="employee.ID"
                        >
                          <a-avatar
                            style="width: 25px; height: 25px"
                            slot="avatar"
                            :src="employee.PERSONAL_PHOTO"
                          />
                          {{ employee.LAST_NAME + " " + employee.NAME }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>

                    <a-form-item :label="$t('NazwaFirmy')">
                      <a-input
                        v-model="companyTitle"
                        @click="handleChangeCompany()"
                        :title="companyTitle"
                      />
                      <!--<a-select
                        showSearch
                        optionFilterProp="children"
                        mode="multiple"
                        v-decorator="[
                          'company',
                          { rules: [{ required: false }] },
                        ]"
                        allowClear
                      >
                        <a-select-option v-for="comp in companies" :key="comp.ID">
                          {{ comp.TITLE }}
                        </a-select-option>
                      </a-select>-->
                    </a-form-item>

                    <a-form-item :label="$t('Contract type')">
                      <a-select
                        showSearch
                        mode="multiple"
                        v-decorator="['type', { rules: [{ required: false }] }]"
                        allowClear
                      >
                        <a-select-option
                          v-for="emplType in employmentеTypes"
                          :key="emplType"
                        >
                          {{ emplType }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>

                    <a-form-item :label="$t('From')">
                      <a-date-picker
                        :format="dateFormat"
                        v-decorator="[
                          'od',
                          { rules: [{ type: 'object', required: false }] },
                        ]"
                      />
                    </a-form-item>

                    <a-form-item :label="$t('To')">
                      <a-date-picker
                        :format="dateFormat"
                        v-decorator="[
                          'do',
                          { rules: [{ type: 'object', required: false }] },
                        ]"
                      />
                    </a-form-item>

                    <a-form-item label="Active">
                      <a-radio-group
                        v-decorator="['radio-active', (initialValue = 'all')]"
                      >
                        <a-radio-button value="all">
                          {{ $t("All") }}
                        </a-radio-button>
                        <a-radio-button value="active">
                          {{ $t("Active") }}
                        </a-radio-button>
                        <a-radio-button value="inactive">
                          {{ $t("Inactive") }}
                        </a-radio-button>
                      </a-radio-group>
                    </a-form-item>

                    <a-form-item
                      style="text-align: center"
                      :label-col="{ span: 0 }"
                      :wrapper-col="{ span: 24 }"
                    >
                      <a-button type="primary" @click="handleSearch">
                        {{ $t("Search") }}
                      </a-button>
                      <a-button @click="handleReset" style="margin-left: 50px">
                        {{ $t("Reset") }}
                      </a-button>
                    </a-form-item>
                  </a-menu-item>
                </a-form>
              </a-menu>
            </a-dropdown>
          </a-col>
          <a-col>
            <a-button
              :disabled="contractTermsData.length == 0"
              type="primary"
              icon="file-excel"
              @click="exportToExcel"
            />
          </a-col>
        </a-row>
      </a-col>
      <a-col v-else-if="reportType == 'employeeStatuses'" style="flex: 1">
        <a-row type="flex" class="search-wrapper">
          <a-col style="flex: 1; margin-right: 15px">
            <a-dropdown :trigger="['click']">
              <a-input-search
                class="ant-dropdown-link height-32"
                :placeholder="$t('Search by')"
                @search="(e) => handleSearch()"
              >
                <template slot="suffix">
                  <a-tooltip>
                    <a-icon
                      type="info-circle"
                      style="color: rgba(0, 0, 0, 0.45); margin-right: 5px"
                    />
                  </a-tooltip>
                </template>
              </a-input-search>

              <a-menu slot="overlay" style="background-color: #fafafa">
                <a-form
                  :form="form"
                  id="my_form_search_styl"
                  layout="vertical"
                  style="padding: 0 50px"
                >
                  <a-menu-item key="2">
                    <a-form-item :label="$t('Name')">
                      <a-select
                        showSearch
                        mode="multiple"
                        v-decorator="['name', { rules: [{ required: false }] }]"
                        allowClear
                        :filter-option="false"
                        @search="searchUser"
                        @focus="usersReport = userInfo"
                      >
                        <a-select-option
                          v-for="employee of usersReport"
                          :key="employee.ID"
                          :value="employee.ID"
                        >
                          <a-avatar
                            style="width: 25px; height: 25px"
                            slot="avatar"
                            :src="employee.PERSONAL_PHOTO"
                          />
                          {{ employee.LAST_NAME + " " + employee.NAME }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>

                    <a-form-item :label="$t('NazwaFirmy')">
                      <a-input
                        v-model="companyTitle"
                        @click="handleChangeCompany()"
                        :title="companyTitle"
                      />
                      <!--<a-select
                        showSearch
                        optionFilterProp="children"
                        mode="multiple"
                        v-decorator="[
                          'company',
                          { rules: [{ required: false }] },
                        ]"
                        allowClear
                      >
                        <a-select-option v-for="comp in companies" :key="comp.ID">
                          {{ comp.TITLE }}
                        </a-select-option>
                      </a-select>-->
                    </a-form-item>

                    <a-form-item :label="$t('UF_DEPARTMENT')">
                      <a-select
                        mode="multiple"
                        v-decorator="[
                          'departament',
                          { rules: [{ required: false }] },
                        ]"
                        allowClear
                      >
                        <a-select-option
                          v-for="i in departments"
                          :key="i.ID"
                          :value="i.ID"
                          >{{ i.NAME }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                    <a-form-item :label="$t('WORK_POSITION')">
                      <a-select
                        v-decorator="[
                          'position',
                          { rules: [{ required: false }] },
                        ]"
                        allowClear
                      >
                        <a-select-option
                          v-for="pos in positionList"
                          :key="pos.ID"
                          :value="pos.WORK_POSITION"
                          >{{ pos.WORK_POSITION }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>

                    <a-form-item :label="$t('Vacation pool')">
                      <a-input
                        v-decorator="[
                          'pulaUrlopowa',
                          { rules: [{ required: false }] },
                        ]"
                      />
                    </a-form-item>
                    <a-form-item :label="$t('Used')">
                      <a-input
                        v-decorator="[
                          'Wykorzystane',
                          { rules: [{ required: false }] },
                        ]"
                      />
                    </a-form-item>
                    <a-form-item :label="$t('Available')">
                      <a-input
                        v-decorator="[
                          'Dostepne',
                          { rules: [{ required: false }] },
                        ]"
                      />
                    </a-form-item>
                    <a-form-item :label="$t('Absences')">
                      <a-input
                        v-decorator="[
                          'Nieobecnosci',
                          { rules: [{ required: false }] },
                        ]"
                      />
                    </a-form-item>

                    <a-form-item>
                      <a-radio-group
                        v-decorator="['radio-active', (initialValue = 'all')]"
                      >
                        <a-radio-button value="all">{{
                          $t("All")
                        }}</a-radio-button>
                        <a-radio-button value="active">{{
                          $t("Active")
                        }}</a-radio-button>
                        <a-radio-button value="inactive">{{
                          $t("Inactive")
                        }}</a-radio-button>
                      </a-radio-group>
                    </a-form-item>

                    <a-form-item
                      style="text-align: center"
                      :label-col="{ span: 0 }"
                      :wrapper-col="{ span: 24 }"
                    >
                      <a-button type="primary" @click="handleSearch">{{
                        $t("Search")
                      }}</a-button>
                      <a-button
                        @click="handleReset"
                        style="margin-left: 50px"
                        >{{ $t("Reset") }}</a-button
                      >
                    </a-form-item>
                  </a-menu-item>
                </a-form>
              </a-menu>
            </a-dropdown>
          </a-col>
          <a-col>
            <a-button
              :disabled="employeeStatusesData.length == 0"
              type="primary"
              icon="file-excel"
              @click="exportToExcel"
            />
          </a-col>
        </a-row>
      </a-col>
    </a-row>

    <a-row v-if="reportType == 'contractTerms'">
      <a-table
        :data-source="contractTermsData"
        :columns="contractTermsColumns"
        :pagination="{
          pageSizeOptions: pageSizeOptions,
          showSizeChanger: true,
          pageSize: pageSize,
          showSizeChange: onShowSizeChange($event),
        }"
        size="small"
        bordered
      ></a-table>
    </a-row>
    <a-row v-else>
      <a-table
        :data-source="employeeStatusesData"
        :columns="employeeStatusesColumns"
        :pagination="{
          pageSizeOptions: pageSizeOptions,
          showSizeChanger: true,
          pageSize: pageSize,
          showSizeChange: onShowSizeChange($event),
        }"
        size="small"
        bordered
      ></a-table>
    </a-row>
  </div>
</template>

<script>
import moment from "moment";
import { updateAuth, generateFormData } from "../requestFunc";
export default {
  props: [
    "userInfo",
    "currentUserIdForEdit",
    "companies",
    "departments",
    "userAccess",
    "DniWRoku",
  ],
  data() {
    return {
      pageSize: 10,
      pageSizeOptions: ["10", "20", "50", "100"],
      contractTermsData: [],
      employeeStatusesData: [],
      companyArrayId: [],
      companyTitle: [],
      employmentеTypes: [
        this.$t("Dzialalnosc gospodarcza"),
        this.$t("Kontrakt menadzerski"),
        this.$t("Praktyki"),
        this.$t("Staz"),
        this.$t("Umowa o prace"),
        this.$t("Umowa zlecenie"),
        this.$t("Umowa o dzielo"),
      ],
      dateFormat: "YYYY-MM-DD",
      form: this.$form.createForm(this, { name: "search" }),
      reportType: "employeeStatuses",
      contractTermsColumns: [
        {
          title: this.$t("Name"),
          dataIndex: "name",
          key: "name",
        },
        {
          title: this.$t("Last name"),
          dataIndex: "lastName",
          key: "lastName",
        },
        {
          title: this.$t("Company"),
          dataIndex: "company",
          key: "company",
        },
        {
          title: this.$t("Contract type"),
          dataIndex: "contractType",
          key: "contractType",
        },
        {
          title: this.$t("Date from"),
          dataIndex: "dateFrom",
          key: "datefrom",
        },
        {
          title: this.$t("Date to"),
          dataIndex: "dateTo",
          key: "dateTo",
        },
      ],
      employeeStatusesColumns: [
        {
          title: this.$t("Name"),
          dataIndex: "name",
          key: "name",
        },
        {
          title: this.$t("Last name"),
          dataIndex: "lastName",
          key: "lastName",
        },
        {
          title: this.$t("Company"),
          dataIndex: "company",
          key: "company",
        },
        {
          title: this.$t("Department"),
          dataIndex: "department",
          key: "department",
          scopedSlots: { customRender: "department" },
        },
        {
          title: this.$t("Position"),
          dataIndex: "position",
          key: "position",
        },
        {
          title: this.$t("Vacation pool"),
          dataIndex: "vacationPool",
          key: "vacationPool",
        },
        {
          title: this.$t("Used"),
          dataIndex: "used",
          key: "used",
        },
        {
          title: this.$t("Available"),
          dataIndex: "available",
          key: "available",
        },
        {
          title: this.$t("Absences"),
          dataIndex: "absences",
          key: "absences",
        },
      ],
      usersReport: [],
      positionList: [],
    };
  },
  methods: {
    moment,
    searchUser(val) {
      this.usersReport = this.userInfo.filter((el) => {
        const str = el.NAME + " " + el.LAST_NAME.toLowerCase();
        let search = str.indexOf(val);
        return +search >= 0;
      });
    },
    UniqueSort(A) {
      let AA = A.map((el) => {
        return el.WORK_POSITION;
      })
        .sort()
        .filter((item) => item != "");
      var n = AA.length,
        B = [AA[0]];
      for (var i = 1, j = 1; i < n; i++) {
        if (AA[i] !== B[j - 1]) B[j++] = AA[i];
      }
      return B;
    },
    handleChangeCompany() {
      // eslint-disable-next-line
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: true,
        },
        (info) => {
          console.log(info, "info");
          this.companyArrayId = [];
          this.companyTitle = [];
          for (var item in info.company) {
            console.log(info.company[item], "item");
            this.companyArrayId.push(info.company[item].id.split("_")[1]);
            this.companyTitle.push(info.company[item].title);
          }
          this.companyTitle = this.companyTitle.join();
          console.log(this.companyArrayId, "vvv111");
          console.log(this.companyTitle, "companyTitle");
          /*this.NazwaFirmy = info.company[0].id.split('_')[1];
            this.companyTitle = info.company[0].title;
            console.log(this.company, 'this.myCompany');
            console.log(this.companyTitle, 'this.myCompanyTitle');*/
        }
      );
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize;
    },
    handlerChangeReportType(e) {
      this.contractTermsData = [];
      this.employeeStatusesData = [];
      this.reportType = e;
    },
    getDepartments(arr) {
      console.log(arr, "arr");
      let item = "";
      if (this.departments) {
        console.log(this.departments, "departments");
        let dep = this.departments
          .map((el) => {
            item = "";
            console.log(arr, "arr2");
            arr.forEach((element) => {
              if (element == el.ID) item = el.NAME;
            });
            return item;
          })
          .filter((i) => i != "");
        return dep;
      }
    },

    async handleSearch() {
      if (
        $(".ant-dropdown-placement-bottomLeft").css("display") != "none" &&
        $(".ant-dropdown-placement-bottomLeft").css("display") != undefined
      ) {
        $(".search-wrapper input").click();
      }
      let valuesForm = {};
      this.form.validateFields((err, values) => {
        if (this.companyArrayId.length) {
          valuesForm["company"] = this.companyArrayId;
        }
        for (let i in values) {
          if (values[i] && values[i].length) {
            valuesForm[i] = values[i];
          }
        }
      });
      let run =
        this.reportType == "contractTerms"
          ? "loadContractTerms"
          : "loadContractDates";
      let url = "/php/request.php";

      let dataSearch = {
        token: updateAuth().token,
        domain: updateAuth().domain,
        run: run,
      };

      if (JSON.stringify(valuesForm) !== JSON.stringify({})) {
        dataSearch.data = JSON.stringify(valuesForm);
      }

      const response = await fetch(url, {
        method: "POST",
        body: generateFormData(dataSearch),
      });
      let result = await response.json();

      if (this.reportType == "employeeStatuses") {
        this.employeeStatusesData = result.data.map((el) => {
          console.log(el, "el");
          let vacationsDays = el.WymiarUrlopu
            ? JSON.parse(el.WymiarUrlopu).filter((el) => {
                if (el.date == this.moment().format("YYYY")) return el;
              }).length != 0
              ? JSON.parse(el.WymiarUrlopu).filter((el) => {
                  if (el.date == this.moment().format("YYYY")) return el;
                })[0].name
              : 0
            : 0;
          return {
            user_id: el.ID,
            name: el.NAME,
            lastName: el.LAST_NAME,
            company:
              el.NazwaFirmy &&
              el.NazwaFirmy != "" &&
              el.NazwaFirmy != "undefined"
                ? el.company.TITLE
                : "",
            department: this.getDepartments(el.UF_DEPARTMENT),
            position: el.WORK_POSITION,
            vacationPool: vacationsDays,
            used: el.useDays != "" ? el.useDays : 0,
            available:
              +vacationsDays - +el.useDays
                ? +vacationsDays - +el.useDays
                : 0 + "",
            absences: el.timeOff != "" ? el.timeOff : 0,
          };
        });
      } else {
        this.contractTermsData = result.data.map((el) => {
          return {
            user_id: el.ID,
            name: el.NAME,
            lastName: el.LAST_NAME,
            company:
              el.NazwaFirmy &&
              el.NazwaFirmy != "" &&
              el.NazwaFirmy != "undefined"
                ? el.company.TITLE
                : "",
            contractType: el.TypZatrudnienia,
            dateFrom: el.DataZatrudnienia,
            dateTo: el.DataZakonczeniaRozwiazania,
          };
        });
      }
    },
    async handleReset() {
      if (
        $(".ant-dropdown-placement-bottomLeft").css("display") != "none" &&
        $(".ant-dropdown-placement-bottomLeft").css("display") != undefined
      ) {
        $(".search-wrapper input").click();
      }
      this.form.resetFields();

      this.companyArrayId = [];
      this.companyTitle = [];

      this.contractTermsData = [];
      this.employeeStatusesData = [];
    },
    async exportToExcel() {
      let run =
        this.reportType == "contractTerms"
          ? "exportContractTerms"
          : "exportContractDates";
      let dataForExport =
        this.reportType == "contractTerms"
          ? this.contractTermsData.map((el) => el.user_id)
          : this.employeeStatusesData.map((el) => el.user_id);

      let url = "/php/request.php";

      const response = await fetch(url, {
        method: "POST",
        body: generateFormData({
          token: updateAuth().token,
          domain: updateAuth().domain,
          run: run,
          lang: BX24.getLang(),
          data: JSON.stringify(dataForExport),
        }),
      });

      const res = await response.json();

      var link = document.createElement("a");
      link.setAttribute("href", res.link);
      link.setAttribute("download", "report.xlsx");
      onload = link.click();
    },
  },
  mounted() {
    BX24.fitWindow();
    this.usersReport = this.userInfo;
    this.positionList = this.userInfo.filter((el) => el.WORK_POSITION);
  },
};
</script>

<style scoped>
#main-additional-wrapper {
  font-weight: 200;
  color: #000;
}
#main-additional-wrapper .ant-table-content th,
#main-additional-wrapper #my_form_search_styl.ant-form.ant-form-vertical {
  font-weight: 400;
  color: #000;
}
#main-additional-wrapper h2 {
  font-weight: 500;
  color: #000;
}

#report-type .ant-select-selection--single {
  height: 32px;
  min-height: 1.7vw;
}
#report-type .ant-select-selection__rendered {
  display: flex;
  height: 100%;
  align-items: center;
}

/* div.ant-select-selection-selected-value {
  height: 32px;
  min-height: 1.7vh;
  padding: 0px;
  margin: 0px;
}

#main-additional-wrapper .ant-select-selection__rendered {
  padding: 0px;
  margin: 0px;
}

#main-additional-wrapper
  .ant-select-dropdown-menu.ant-select-dropdown-menu-root.ant-select-dropdown-menu-vertical {
  padding: 0px;
  margin: 0px;
}

#main-additional-wrapper .ant-select-dropdown-menu-item {
  padding: 0px;
  margin: 0px;
} */
</style>
